import { ItemView } from '@glu/core';
import template from './viewingDetails.hbs';

export default ItemView.extend({
  template,

  templateHelpers() {
    return this.options.data;
  }
});
